/**
 * Check for orphaned addon items (Product B without Product A) and remove them
 * This ensures that addon products cannot exist in the cart without their main product
 */
(function() {
  'use strict';

  const MAIN_PRODUCT_ID = 7315640647738;
  const ADDON_PRODUCT_ID = 7335771570234;

  /**
   * Check for orphaned addon items and remove them if main product is not present
   */
  async function checkForOrphanedAddons() {
    try {
      // Fetch current cart via API
      const response = await fetch('/cart.js');
      if (!response.ok) {
        console.error('Failed to fetch cart data');
        return;
      }

      const cart = await response.json();

      let hasMainProduct = false;
      let addonItemsToRemove = [];

      // Check what products are in the cart
      cart.items.forEach((item) => {
        if (item.product_id === MAIN_PRODUCT_ID) {
          hasMainProduct = true;
        } else if (item.product_id === ADDON_PRODUCT_ID) {
          addonItemsToRemove.push(item.key);
        }
      });

      // If addon exists but main product doesn't, remove the addon
      if (!hasMainProduct && addonItemsToRemove.length > 0) {
        console.log('Removing orphaned addon items');

        for (const itemKey of addonItemsToRemove) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: itemKey,
                quantity: 0,
              }),
            });

            // Remove from DOM if on cart page
            const row = document.querySelector(`tr[data-item-key="${itemKey}"]`);
            if (row) {
              row.remove();
            }
          } catch (error) {
            console.error('Error removing orphaned addon:', error);
          }
        }

        // Refresh cart UI if on cart page
        try {
          const finalResponse = await fetch('/cart.js');
          if (finalResponse.ok) {
            const updatedCart = await finalResponse.json();
            updateCartUI(updatedCart);
          }
        } catch (error) {
          console.error('Error refreshing cart:', error);
        }
      }
    } catch (error) {
      console.error('Error checking for orphaned addons:', error);
    }
  }

  // Run check when DOM is ready (since script is deferred)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkForOrphanedAddons);
  } else {
    // DOM already loaded
    checkForOrphanedAddons();
  }
})();

